const youtubeVideoKeys = {
    all: () => [{ entity: 'youtubeVideo' }],
    allDetails: () => [{ ...youtubeVideoKeys.all()[0], scope: 'detail' }],
    detailById: (rawEpisodeId) => [
        { ...youtubeVideoKeys.allDetails()[0], episodeId: Number(rawEpisodeId) },
    ],
};

export default youtubeVideoKeys;
